import React from 'react';
import { useParams } from 'react-router-dom';
import ProductDetailContent from '../../components/products/ProductDetailContent';

const ProductPage = () => {
  const { productId } = useParams();

  return (
    <div className="product-page">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="product-page__content">
              <ProductDetailContent 
                productId={productId} 
                isModal={false}
              />
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .product-page {
          min-height: 100vh;
          background-color: #f8f9fa;
          padding: 2rem 0;
        }

        .product-page__content {
          background: white;
          border-radius: 0.5rem;
          box-shadow: 0 2px 10px rgba(0,0,0,0.1);
          padding: 2rem;
          margin-bottom: 2rem;
        }

        @media (max-width: 768px) {
          .product-page {
            padding: 1rem 0;
          }
          
          .product-page__content {
            margin: 0;
            border-radius: 0;
            box-shadow: none;
            padding: 1rem;
          }
        }
      `}</style>
    </div>
  );
};

export default ProductPage;